import { render } from "./UpdateDropdown.vue?vue&type=template&id=959de414"
import script from "./UpdateDropdown.vue?vue&type=script&lang=js"
export * from "./UpdateDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script